module.exports = __webpack_public_path__ + "img/dirt-1.d0bf0324.png";